// import { DtrfForm } from "@aiolosdev/dtrf-form-dev/dist";
import { DtrfForm } from "b2c6a1a8wq-ak/dist";
import React, { useContext } from "react";
import { connect } from "react-redux";
import Head from "next/head";
import { useState, useEffect } from "react";

import "../../css/app.min.css";
import "../../css/style.css";
import "../../css/components.css";
import "../../css/custom.css";
// import "../../form/css/font-awesome.min.css";
// import "../form/css/multistep.min.css";
// import "../bundles/pretty-checkbox/pretty-checkbox.min.css";
import "../../css/custom-responsive.css";
import "../../css/animate.min.css";
import config from "../../config";
import HeaderContext from "../../context/HeaderContext";

const TestEmergencyDtrf = (props) => {
  const [doctorDetails, setDoctorDetails] = useState(null);
  const url = {
    institute: config.api.base_url + "institute/get-dropdown-list",
    test: config.api.base_url + "test-master/get-dropdown-list",
    testValid: config.api.base_url + "v1/dtrf/check-integrated-done",
    patient: config.api.base_url + "patient/on-dtrf-search",
    patientValid: config.api.base_url + "v1/patient/check-patient",
    containers:
      config.api.base_url + "emergency-dtrf/get-dropdown-list-for-container",
    checkPatient: config.api.base_url + "v1/patient/check-patient",
    getFlow: config.api.base_url + "",
    sampleContainerValidator:
      config.api.base_url + "emergency-dtrf/sample-validator",
    submit: config.api.base_url + "emergency-dtrf/submit",
  };
  const {setTitle} = useContext(HeaderContext);
  setTitle("Emergency Dtrf");

  useEffect(() => {
    if (doctorDetails == null) {
      if (props.getDoctorDetailState.apiState === "success") {
        console.log("ID => ", props.getDoctorDetailState.data._id);

        setDoctorDetails({
          doctorName: {
            _id: props.getDoctorDetailState.data._id,
            fname: props.getDoctorDetailState.data.fname,
            lname: props.getDoctorDetailState.data.lname,
            nt_status_for_reporting:
              props.getDoctorDetailState.data.nt_status_for_reporting,
            label:
              props.getDoctorDetailState.data.fname +
              " " +
              props.getDoctorDetailState.data.lname,
            value: props.getDoctorDetailState.data._id,
          },
        });
      }
    }
  });
  console.log("props = >", props);
  return (
    <>
      <Head>
        <script src="../../js/app.min.js"></script>
        <script src="bundles/prism/prism.js"></script>
        <script src="bundles/jquery-pwstrength/jquery.pwstrength.min.js"></script>
        <script src="bundles/bootstrap-daterangepicker/daterangepicker.js"></script>
        <script src="bundles/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js"></script>
        <script src="bundles/bootstrap-timepicker/js/bootstrap-timepicker.min.js"></script>
        <script src="bundles/bootstrap-tagsinput/dist/bootstrap-tagsinput.min.js"></script>
        <link
          rel="stylesheet"
          href="bundles/select2/dist/css/select2.min.css"
        />
        <script src="bundles/select2/dist/js/select2.full.min.js"></script>
        <script src="bundles/jquery-selectric/jquery.selectric.min.js"></script>
        <script src="../../js/scripts.js"></script>
        <script src="../../js/custom.js"></script>
      </Head>
      {doctorDetails !== null && (
        <DtrfForm
          fromEmergencyDtrf={true}
          url={url}
          doctor_info={doctorDetails}
        ></DtrfForm>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  getListTestMasterState: state.getListTestMaster,
  getContainerListState: state.getContainerList,
  getDoctorDetailState: state.getDoctorDetail,
  getPatientDropdownListState: state.getPatientDropdownList,
  saveEmergencyDtrfState: state.saveEmergencyDtrf,
});
export default connect(mapStateToProps)(TestEmergencyDtrf);
